import type { Href } from "expo-router";
import { router } from "expo-router";

import { MarketingHead } from "../components/MarketingHead";
import { META_PRIVACY } from "../lib/marketingMeta";
import {
  Linking,
  Platform,
  Pressable,
  ScrollView,
  Text,
  useWindowDimensions,
  View,
} from "react-native";
import { COLORS, FONTS } from "../lib/brand";

const AMBER = COLORS.AMBER.hex;
const LINEN = COLORS.LINEN.hex;
const TEXT_DIM = "rgba(237,232,223,0.62)";
const TEXT_FAINT = "rgba(237,232,223,0.40)";
const PAGE_BG = COLORS.FOREST_DEEPER.hex;

export default function PrivacyScreen() {
  const { width } = useWindowDimensions();
  const wide = width >= 900;
  const pad = wide ? 64 : 22;

  return (
    <>
      <MarketingHead meta={META_PRIVACY} />
      <ScrollView
        style={{ flex: 1, backgroundColor: PAGE_BG }}
        contentContainerStyle={{ paddingBottom: 64 }}
      >
        <View
          style={{
            paddingHorizontal: pad,
            paddingTop: 32,
            alignSelf: "center",
            width: "100%",
            maxWidth: 760,
          }}
        >
          <Pressable
            onPress={() => router.replace("/" as Href)}
            style={[
              { alignSelf: "flex-start", paddingVertical: 4, marginBottom: 12 },
              Platform.OS === "web" ? ({ cursor: "pointer" } as const) : null,
            ]}
          >
            <Text
              style={{
                fontFamily: FONTS.bodyMedium,
                fontSize: 11.5,
                letterSpacing: 1.2,
                textTransform: "uppercase",
                color: TEXT_FAINT,
              }}
            >
              ← Coravu
            </Text>
          </Pressable>

          <View style={{ marginTop: wide ? 28 : 16 }}>
            <Text
              style={{
                fontFamily: FONTS.bodyBold,
                fontSize: 11,
                letterSpacing: 2.4,
                textTransform: "uppercase",
                color: AMBER,
              }}
            >
              Legal
            </Text>
            <Text
              style={{
                marginTop: 12,
                fontFamily: FONTS.display,
                fontSize: wide ? 56 : 40,
                lineHeight: wide ? 60 : 44,
                color: LINEN,
                letterSpacing: -1,
              }}
            >
              Privacy Policy
            </Text>
            <Text
              style={{
                marginTop: 24,
                fontFamily: FONTS.body,
                fontSize: wide ? 16 : 14,
                lineHeight: wide ? 26 : 23,
                color: TEXT_DIM,
              }}
            >
              Our full Privacy Policy is being finalized and will be published before public launch.
              Questions in the meantime? Email{" "}
              <Text
                onPress={() => {
                  if (Platform.OS === "web" && typeof window !== "undefined") {
                    window.location.href = "mailto:tyler@coravu.com";
                  } else {
                    void Linking.openURL("mailto:tyler@coravu.com");
                  }
                }}
                style={{ color: AMBER, fontFamily: FONTS.bodyMedium }}
              >
                tyler@coravu.com
              </Text>
              .
            </Text>
          </View>
        </View>
      </ScrollView>
    </>
  );
}
